var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideFixedIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6802 22.0905L24.1375 19.4682C23.2513 18.9593 22.1192 19.2617 21.6065 20.1461L21.4279 20.4562C20.58 21.9244 18.7038 22.4266 17.2357 21.5797C17.1291 21.5183 17.0273 21.451 16.9284 21.3771C15.443 20.2584 14.0392 19.0361 12.7266 17.7186C11.4092 16.406 10.1869 15.0012 9.06829 13.5157C8.05144 12.1599 8.3251 10.2366 9.68089 9.2197C9.77883 9.14576 9.88157 9.07855 9.98815 9.01709L10.2983 8.83753C11.1826 8.32381 11.4861 7.19267 10.9771 6.30542L8.3539 1.7626C7.89781 0.963689 6.92322 0.62377 6.06961 0.96561L6.01295 0.987695C5.13726 1.32857 2.63884 2.24943 1.99839 2.8899C1.89469 2.9936 1.79675 3.10403 1.70649 3.21926C0.137538 5.2242 0.923935 8.48225 1.75258 10.6207C3.27833 14.5566 6.17043 18.3428 9.1355 21.308C12.1006 24.2731 15.8866 27.1663 19.8224 28.6911C21.1869 29.2202 22.7232 29.6389 24.1961 29.6389C25.429 29.6389 26.659 29.3393 27.5539 28.4453C28.1848 27.8144 29.1152 25.2939 29.457 24.4268L29.4791 24.3711C29.8209 23.5184 29.4791 22.5438 28.6802 22.0896V22.0905Z",
    fill: "#BC9850"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8477 3.09134C14.8477 3.62139 15.2778 4.05157 15.8078 4.05157C21.6525 4.05157 26.3901 8.79028 26.3911 14.6352C26.3911 15.1652 26.8213 15.5954 27.3513 15.5954C27.8813 15.5954 28.3115 15.1652 28.3115 14.6352C28.3115 7.73019 22.7136 2.13208 15.8078 2.13208C15.2778 2.13208 14.8477 2.56226 14.8477 3.0923V3.09134Z",
    fill: "#BC9850"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8477 8.45125C14.8477 8.9813 15.2778 9.41148 15.8078 9.41148C18.6903 9.41436 21.0265 11.7515 21.0303 14.6341C21.0303 15.1642 21.4605 15.5944 21.9905 15.5944C22.5206 15.5944 22.9507 15.1642 22.9507 14.6341C22.9459 10.6915 19.7514 7.49583 15.8078 7.49103C15.2778 7.49103 14.8477 7.92121 14.8477 8.45125Z",
    fill: "#BC9850"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideFixedIcon4);
export default __webpack_public_path__ + "static/media/side-fixed-icon4.bc4799b13d0d5bee548dd0f7c191644e.svg";
export { ForwardRef as ReactComponent };